/* eslint-disable jsx-a11y/anchor-is-valid */
import secondaryComponents from "../../../../../components/secondaryComponents";
import { motion } from "framer-motion";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import primaryComponents from "../../../../../components/primaryComponents";
import { PlusIcon } from "../../../../../assets/svgIcons";
import { useAllSmsCampaigns } from "./useAllSmsCampaigns";
import { SmsCampaignTable } from "../../../../../components/secondaryComponents/SmsCampaign";
import { Outlet, useNavigate } from "react-router-dom";
import { pathConstants } from "../../../../../routes/pathContants";

const AllSmsCampaigns = () => {
  const {
    search,
    isLoadingSmsCampaigns,
    campaigns,
    metaDetails,
    gotoPage,
    filterBySearch,
    filterByKey,
  } = useAllSmsCampaigns();
  const navigate = useNavigate();

  const statusOption = [
    { id: "DRAFT", name: "Draft" },
    { id: "SCHEDULED", name: "Scheduled" },
    { id: "ONGOING", name: "Ongoing" },
    { id: "COMPLETED", name: "Completed" },
    { id: "PAUSED", name: "Paused" },
    { id: "CANCELLED", name: "Cancelled" },
  ];
  const typeOption = [
    { id: "IMMEDIATE", name: "Instantly" },
    { id: "SCHEDULED_ONCE", name: "Schedule Once" },
    { id: "RECURRING", name: "Recurring" },
  ];

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | SMS Campaigns - Custom"
      description="View all custom SMS campaigns"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={`${globalStyles.pageColumnGaps}`}
        >
          <div className={globalStyles.pageHeaders}>
            <p>{metaDetails?.total || 0} SMS campaigns</p>

            <primaryComponents.Button
              classNames={"btn btn--primary"}
              onClick={() =>
                navigate(pathConstants.MARKETING_SMS_CAMPAIGNS_CREATE)
              }
            >
              <PlusIcon className="mr-1" />
              Create Campaign
            </primaryComponents.Button>
          </div>

          {/* table section */}
          <div className={`${globalStyles.tableWrapper}`}>
            <div className={`${globalStyles.tableHeader}`}>
              <primaryComponents.SearchField
                classNames={`${globalStyles.searchField}`}
                placeholder="Search by campaign name or ID"
                trigger={(value) => filterBySearch(value)}
                value={search.get("query") || ""}
                triggerOnInput={true}
                showsearchBtn={true}
              />

              <div className="ml-auto" style={{ width: "180px" }}>
                <primaryComponents.SelectField
                  options={[
                    {
                      name: "All Status",
                      id: null,
                    },
                    ...statusOption,
                  ]}
                  idKey="id"
                  nameKey="name"
                  onChange={(value) => {
                    filterByKey("status", value);
                  }}
                  value={
                    statusOption?.find(
                      (item) => `${item?.id}` === search.get("status"),
                    )?.name || "Filter status"
                  }
                  floatError={false}
                  isSearchable={false}
                />
              </div>
              <div style={{ width: "180px" }}>
                <primaryComponents.SelectField
                  options={[
                    {
                      name: "All Types",
                      id: null,
                    },
                    ...typeOption,
                  ]}
                  idKey="id"
                  nameKey="name"
                  onChange={(value) => {
                    filterByKey("delivery_type", value);
                  }}
                  value={
                    typeOption?.find(
                      (item) => `${item?.id}` === search.get("delivery_type"),
                    )?.name || "Filter type"
                  }
                  floatError={false}
                  isSearchable={false}
                />
              </div>
            </div>

            {/* table section */}
            <secondaryComponents.LoaderHelper
              isLoading={isLoadingSmsCampaigns}
              classNames="mt-5"
            >
              <SmsCampaignTable
                campaigns={campaigns}
                metaDetails={metaDetails}
                gotoPage={gotoPage}
              />
            </secondaryComponents.LoaderHelper>
          </div>
        </motion.div>

        <Outlet />
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};
export default AllSmsCampaigns;
